import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header/Header";
import { useEffect, useState } from "react";

const Main = () => {
  const [keyword, setKeyword] = useState("");
  const [selectedAreas, setSelectedAreas] = useState<any[]>([]);
  const { pathname } = useLocation();
  const useScrollableHeader = false;
  const hasActiveHeaderFilters =
    selectedAreas.length > 0 &&
    !['/item-list', '/menu', '/cart', '/cart/success', '/payment-details', '/payment-method', '/splitt-bill', '/receipt', '/email-receipt', '/email-success', '/qr-display'].includes(pathname);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <Header
        onSearch={(value: any) => setKeyword(value)}
        selectedArea={(value: any) => setSelectedAreas(value)}
        useScrollableHeader={useScrollableHeader}
      />
      <div id="main-app" className="layout-veritcle-menu">

        <div className={`app-body${useScrollableHeader ? " app-body--scroll-header" : ""}${hasActiveHeaderFilters ? " app-body--with-filter-summary" : ""}`}>
          <Outlet context={{ keyword, selectedAreas }} />
        </div>
      </div>
    </>
  );
};

export default Main;
